<template>
    <div class="bg-b">
        <div class="nor-h2">
            <div class="container">
                <h2 class="pt-sans-bol ">
                    <!-- <span class="el-icon-menu"></span> -->
                    <span style="float:left"></span>
                    LISTADO DE OFERTA DE TRAYECTOS FORMATIVOS

                    <!-- <span class="el-icon-s-operation" style="float:right"></span> -->
                </h2>
            </div>

        </div>

        <div class="container">
            <div class="card-grid">
                <capaCard v-for="(card, index) in capas" :key="index" :card="card"  />
            </div>
             


            </div>
        </div>
</template>

<script>
import capaCard from '@/components/capa.vue'

    export default {
    components: {
            capaCard
    },
        data() {
            return {
                capas: [],
                currentDate: new Date()
            }
        },
    created() {
      
    },
        methods: {
            verCapa(id) {
                this.$router.push({name:'prueba', params:{id}})
            }
        },
       
       
    }
</script>
<style>
.card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
    padding: 16px;
}
.listado {
    margin-top: 0px;
    height: calc(100vh - 200px);
    overflow: overlay;
    scrollbar-gutter: auto;
    overflow-x: hidden;
 
                /* Oculta las flechas del scroll */

}


</style>